import type { LowerHex } from '../../types'
import type { KaiascanClient } from './client'
import { kaiascanTransactionInfoSchema } from './schema'

export type KaiascanTransactionInfo = {
  blockNumber: number
  timestamp: number
}

type GetTransactionInfoParameters = {
  client: KaiascanClient
  txhash: LowerHex
  headers?: Record<string, string>
}

/**
 * Kaiascan から transaction info を取得する。
 *
 * @param parameters - client、transaction hash、headers。
 * @returns block number と timestamp。
 */
export const getTransactionInfo = async ({
  client,
  txhash,
  headers,
}: GetTransactionInfoParameters): Promise<KaiascanTransactionInfo> =>
  client.get({
    path: '',
    query: {
      module: 'transaction',
      action: 'gettxinfo',
      txhash,
    },
    resultSchema: kaiascanTransactionInfoSchema,
    headers,
  })
